module.exports = __webpack_public_path__ + "static/img/products background img_purple.3e8f0511.jpg";